import { Building2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useGetSucursaleUe } from "@/hooks/api/query/useGetSucursaleUe";

type SucursaleUeSugestieProps = {
  cui: string | undefined;
  onComplete: (tari: string) => void;
};

function SucursaleUeSugestie({ cui, onComplete }: SucursaleUeSugestieProps) {
  const { data } = useGetSucursaleUe(cui);

  const tari = Array.from(
    new Set(
      (data?.sucursale ?? [])
        .map((sucursala) => sucursala.tara)
        .filter((tara): tara is string => Boolean(tara))
    )
  );

  if (tari.length === 0) return null;

  return (
    <div className="flex flex-col gap-2 rounded-lg border border-ds-blue-200 bg-ds-blue-50/70 p-3 md:flex-row md:items-center md:justify-between">
      <div className="flex items-start gap-2">
        <Building2 className="h-4 w-4 mt-0.5 shrink-0 text-ds-blue-500" />
        <span className="text-xs text-ds-blue-700">
          {data?.snapshot ? `${data.snapshot}: ` : "ONRC: "}
          sucursale în {tari.join(", ")}
        </span>
      </div>
      <Button
        type="button"
        size="sm"
        variant="outline"
        className="shrink-0 h-7 text-xs"
        onClick={() => onComplete(tari.join(", "))}
      >
        Completează
      </Button>
    </div>
  );
}

export default SucursaleUeSugestie;
